"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analyticActiveLogListApi = analyticActiveLogListApi;
exports.analyticActiveSnapshoptListApi = analyticActiveSnapshoptListApi;
exports.analyticFetchRecordScoreApi = analyticFetchRecordScoreApi;
exports.changeLogActorListApi = changeLogActorListApi;
exports.changeLogChangesPerformedListApi = changeLogChangesPerformedListApi;
exports.changeLogComponentListApi = changeLogComponentListApi;
exports.changeLogListApi = changeLogListApi;
exports.changeLogListPlatformApi = changeLogListPlatformApi;
exports.changeLogMediumListApi = changeLogMediumListApi;
exports.changeLogModuleListApi = changeLogModuleListApi;
exports.recipientAnalyticsActivityLogHistoryApi = recipientAnalyticsActivityLogHistoryApi;
exports.recipientAnalyticsFindApi = recipientAnalyticsFindApi;
exports.recipientAnalyticsGetApi = recipientAnalyticsGetApi;
exports.recipientAnalyticsLatestSessionRecordingApi = recipientAnalyticsLatestSessionRecordingApi;
exports.recipientAnalyticsRecentActivityApi = recipientAnalyticsRecentActivityApi;
exports.recipientAnalyticsSaveApi = recipientAnalyticsSaveApi;
exports.recipientAnalyticsScoreApi = recipientAnalyticsScoreApi;
exports.recipientAnalyticsUpdateApi = recipientAnalyticsUpdateApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function analyticActiveLogListApi(params) {
  return generateResponse(params);
}
/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function analyticActiveSnapshoptListApi(params) {
  return generateResponse(params);
}
var generateResponse = function generateResponse(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AnalyticsService.analytics.activityLog), params);
};

/**
 * fetch record score
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function analyticFetchRecordScoreApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AnalyticsService.analytics.fetchRecordScore), params);
}

/**
 * change log list
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function changeLogListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AnalyticsService.changeLog.list), params);
}

/**
 * change log list for platform
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function changeLogListPlatformApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AnalyticsService.changeLog.listPlatform), params);
}

/**
 * change log list for changes performed
 * @param payload
 * @returns api response
 * @description this function used to get data of changes performed.
 */
function changeLogChangesPerformedListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AnalyticsService.changeLog.changesPerformed), params);
}

/**
 * change log list of medium
 * @param payload
 * @returns api response
 * @description this function used to get data of medium.
 */
function changeLogMediumListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AnalyticsService.changeLog.mediumList), params);
}

/**
 * change log list of medium
 * @param payload
 * @returns api response
 * @description this function used to get data of medium.
 */
function changeLogModuleListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AnalyticsService.changeLog.moduleList), params);
}

/**
 * change log list of component
 * @param payload
 * @returns api response
 * @description this function used to get data of component.
 */
function changeLogComponentListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AnalyticsService.changeLog.componentList), params);
}

/**
 * change log list of actor
 * @param payload
 * @returns api response
 * @description this function used to get data of component.
 */
function changeLogActorListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AnalyticsService.changeLog.actorList), params);
}

// analytics

/**
 * Analytics Save
 * @param payload
 * @returns api response
 * @description this function used to Analytics Save.
 */
function recipientAnalyticsSaveApi(payload) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.AnalyticsService.recipient.analyticsSave), payload);
}

/**
 * Analytics Get
 * @param payload
 * @returns api response
 * @description this function used to Analytics Get.
 */
function recipientAnalyticsGetApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AnalyticsService.recipient.analyticsGet), payload);
}

/**
 * Analytics Update
 * @param payload
 * @returns api response
 * @description this function used to Analytics Update.
 */
function recipientAnalyticsUpdateApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.AnalyticsService.recipient.analyticsUpdate), payload);
}

/**
 * Analytics Recent Activity
 * @param payload
 * @returns api response
 * @description this function used to Analytics Recent Activity.
 */
function recipientAnalyticsRecentActivityApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AnalyticsService.recipient.analyticsRecentActivity), payload);
}

/**
 * Analytics Find
 * @param payload
 * @returns api response
 * @description this function used to Analytics Find.
 */
function recipientAnalyticsFindApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AnalyticsService.recipient.analyticsFind), payload);
}

/**
 * Analytics Activity Log History
 * @param payload
 * @returns api response
 * @description this function used to Analytics Activity Log History.
 */
function recipientAnalyticsActivityLogHistoryApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AnalyticsService.recipient.analyticsActivityLogHistory), payload);
}

/**
 * Analytics Latest Session Recording
 * @param payload
 * @returns api response
 * @description this function used to Analytics Latest Session Recording.
 */
function recipientAnalyticsLatestSessionRecordingApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AnalyticsService.recipient.analyticsLatestSessionRecording), payload);
}

/**
 * Analytics Score
 * @param payload
 * @returns api response
 * @description this function used to Analytics Score.
 */
function recipientAnalyticsScoreApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AnalyticsService.recipient.analyticsScore), payload);
}